import { Subscription, Observable, Subject } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { CoreService } from '../../services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { Color, ColorPickerControl, ColorsTable } from '@iplab/ngx-color-picker';
import { QrDownloadFileTypes } from '@app/store/enums/qr-download-file-types.enum';
import { BASE_64_ENCODED, FunctionsService } from '../../services/functions.service';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';
import { LandingPageLoggerDataModes, QrGeneratorFrameTypes, QrGeneratorNavigatorBitcoins, QrGeneratorNavigatorCategories, QrGeneratorNavigatorEMAIL, QrGeneratorNavigatorLOCATION, QrGeneratorNavigatorSMS, QrGeneratorNavigatorTEXT, QrGeneratorNavigatorURL, QrGeneratorNavigatorVCARD, QrGeneratorNavigatorWEBSITE, QrGeneratorNavigatorWIFI, QrThemeCornerOptions, QrThemeDotTypesMini } from 'shared-library';

declare const QRCodeStyling: any

@Component({
  selector: 'app-core-download-qr',
  templateUrl: './core-download-qr.component.html',
  styleUrls: ['./core-download-qr.component.scss']
})
export class CoreDownloadQrComponent implements OnInit {

  qr_data_to_encode = ""

  timer_cc: any
  _data: QrGeneratorNavigator
  timer_ccolor: any
  data: QrGeneratorNavigatorWEBSITE | QrGeneratorNavigatorVCARD | QrGeneratorNavigatorSMS | QrGeneratorNavigatorEMAIL | QrGeneratorNavigatorTEXT | QrGeneratorNavigatorURL | QrGeneratorNavigatorBitcoins | QrGeneratorNavigatorWIFI | QrGeneratorNavigatorLOCATION

  private subscriptions: Subscription[] = []
  custom_logo_id = this.qrGeneratorService.getCustomLogoId()
  primary_color_obs: Subject<string> = new Subject<string>()
  @Input() selected_category: QrGeneratorNavigatorCategories;
  @Input() selected_category_obs: Observable<QrGeneratorNavigatorCategories>;


  qrCode: any
  session_info: SessionInfo
  qrContainer: any = document.createElement("div")
  chromeControl1 = new ColorPickerControl().setValueFrom(ColorsTable.aquamarine).hideAlphaChannel()
  chromeControl2 = new ColorPickerControl().setValueFrom(ColorsTable.aquamarine).hideAlphaChannel()
  chromeControl3 = new ColorPickerControl().setValueFrom(ColorsTable.aquamarine).hideAlphaChannel()
  chromeControl4 = new ColorPickerControl().setValueFrom(ColorsTable.aquamarine).hideAlphaChannel()
  chromeControl5 = new ColorPickerControl().setValueFrom(ColorsTable.aquamarine).hideAlphaChannel()

  file_helper: { showing: boolean; input_url: string; error: string; base64: BASE_64_ENCODED; file: File } = {
    showing: false,
    input_url: "",
    error: "",
    base64: null,
    file: null
  }

  frame_types = {
    STYLE1: QrGeneratorFrameTypes.STYLE1,
    STYLE2: QrGeneratorFrameTypes.STYLE2,
    STYLE3: QrGeneratorFrameTypes.STYLE3,
    STYLE4: QrGeneratorFrameTypes.STYLE4,
    STYLE5: QrGeneratorFrameTypes.STYLE5,
    STYLE6: QrGeneratorFrameTypes.STYLE6,
  }

  file_downloadable_types = {
    PNG: QrDownloadFileTypes.PNG,
    SVG: QrDownloadFileTypes.SVG,
    JPEG: QrDownloadFileTypes.JPEG,
  }
  private logged: { text: string; extension: QrDownloadFileTypes; }[] = []

  corner_options = {
    DOT: QrThemeCornerOptions.DOT,
    DOTS: QrThemeCornerOptions.DOTS,
    SQUARE: QrThemeCornerOptions.SQUARE,
    CLASSY: QrThemeCornerOptions.CLASSY,
    ROUNDED: QrThemeCornerOptions.ROUNDED,
    EXTRA_ROUNDED: QrThemeCornerOptions.EXTRA_ROUNDED,
    CLASSY_ROUNDED: QrThemeCornerOptions.CLASSY_ROUNDED,
  }

  corner_options_mini: Record<QrThemeDotTypesMini, QrThemeDotTypesMini> = {
    dot: QrThemeCornerOptions.DOT,
    square: QrThemeCornerOptions.SQUARE,
    "extra-rounded": QrThemeCornerOptions.EXTRA_ROUNDED,
  }

  constructor(
    private coreService: CoreService,
    private functions: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si
      this.resolveData()
    }))
  }

  ngOnInit(): void {
    this.subscriptions.push(this.selected_category_obs.subscribe(data => {
      this.selected_category = data
      this.resolveData()
    }))
    this.subscriptions.push(this.chromeControl1.valueChanges.subscribe((value: Color) => { this._data.style_settings.frame.color = value.toHexString() }));
    this.subscriptions.push(this.chromeControl2.valueChanges.subscribe((value: Color) => { this._data.style_settings.qr_style.dotsOptions.color = value.toHexString(); clearTimeout(this.timer_ccolor); this.timer_ccolor = setTimeout(() => this.regenerateQR(), 100) }));
    this.subscriptions.push(this.chromeControl3.valueChanges.subscribe((value: Color) => { this._data.style_settings.qr_style.backgroundOptions.color = value.toHexString(); clearTimeout(this.timer_ccolor); this.timer_ccolor = setTimeout(() => this.regenerateQR(), 100) }));
    this.subscriptions.push(this.chromeControl4.valueChanges.subscribe((value: Color) => { this._data.style_settings.qr_style.cornersSquareOptions.color = value.toHexString(); clearTimeout(this.timer_ccolor); this.timer_ccolor = setTimeout(() => this.regenerateQR(), 100) }));
    this.subscriptions.push(this.chromeControl5.valueChanges.subscribe((value: Color) => { this._data.style_settings.qr_style.cornersDotOptions.color = value.toHexString(); clearTimeout(this.timer_ccolor); this.timer_ccolor = setTimeout(() => this.regenerateQR(), 100) }));
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  private resolveData() {
    this._data = this.session_info.qr_generating.drafts.find(d => d.selected_category === this.selected_category)
    if (!this._data) return
    this.qr_data_to_encode = ""

    if (QrGeneratorNavigatorCategories.WEBSITE === this._data.selected_category) {
      if (this.functions.is_valid_url(this._data.website_data.url) && this.qr_data_to_encode !== this._data.website_data.url) {
        this.qr_data_to_encode = this._data.website_data.url
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.website_data
      return
    }

    if (QrGeneratorNavigatorCategories.VCARD === this._data.selected_category) {
      const qr_data_to_encode = this.qrGeneratorService.saveVCardToDevice(this._data.vcard_data)
      if (this._data.vcard_data.mobile && this.qr_data_to_encode !== qr_data_to_encode) {
        this.qr_data_to_encode = qr_data_to_encode
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.vcard_data
      return
    }

    if (QrGeneratorNavigatorCategories.EMAIL === this._data.selected_category) {

      let body = this._data.email_data.body || ""
      let subject = this._data.email_data.subject || ""
      let content = `mailto:${this._data.email_data.email}?subject=${subject}&body=${body}`

      if (this.functions.isEmail(this._data.email_data.email) && this.qr_data_to_encode !== content) {
        this.qr_data_to_encode = content
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.email_data
      return
    }

    if (QrGeneratorNavigatorCategories.SMS === this._data.selected_category) {

      let body = this._data.sms_data.body || ""
      let content = `sms:${this._data.sms_data.mobile}?body=${body}`

      if (this._data.sms_data.mobile && this.qr_data_to_encode !== content) {
        this.qr_data_to_encode = content
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.sms_data
      return
    }

    if (QrGeneratorNavigatorCategories.TEXT === this._data.selected_category) {
      if (this._data.text_data.text && this.qr_data_to_encode !== this._data.text_data.text) {
        this.qr_data_to_encode = this._data.text_data.text
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.text_data
      return
    }

    if (QrGeneratorNavigatorCategories.URL === this._data.selected_category) {
      if (this._data.url_data.url && this.qr_data_to_encode !== this._data.url_data.url) {
        this.qr_data_to_encode = this._data.url_data.url
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.url_data
      return
    }

    if (QrGeneratorNavigatorCategories.LOCATION === this._data.selected_category) {
      if (this._data.location_data.url && this.qr_data_to_encode !== this._data.location_data.url) {
        this.qr_data_to_encode = this._data.location_data.url
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.location_data
      return
    }

    if (QrGeneratorNavigatorCategories.BITCOIN === this._data.selected_category) {
      let content = `${this._data.bitcoin_data.cryptocurrency}:${this._data.bitcoin_data.address}?amount=${this._data.bitcoin_data.amount}`
      if (this._data.bitcoin_data.message) content = `${content}&message=${this._data.bitcoin_data.message}`

      if (this._data.bitcoin_data.amount && this._data.bitcoin_data.address && this.qr_data_to_encode !== content) {
        this.qr_data_to_encode = content
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.bitcoin_data
      return
    }

    if (QrGeneratorNavigatorCategories.WIFI === this._data.selected_category) {
      const content = `WIFI:T:${this._data.wifi_data.encryption};S:${this._data.wifi_data.ssid};P:${this._data.wifi_data.password};H:${this._data.wifi_data.hidden};;`
      if (this._data.wifi_data.ssid && this._data.wifi_data.password && content && this.qr_data_to_encode !== content) {
        this.qr_data_to_encode = content
        this.regenerateQR()
      }
      this.functions.logToConsole(this.qr_data_to_encode)
      this.data = this._data.wifi_data
      return
    }

  }

  changeFrame(to?: QrGeneratorFrameTypes) {
    if (this._data.style_settings.frame.type !== to) {
      this._data.style_settings.frame.type = to
    }
  }

  async regenerateQR() {
    this._data.processing = true
    this._data.style_settings.qr_style.data = this.qr_data_to_encode

    let time_cc = 1000
    let overhead_delay = false
    this._data.processing = true

    this._data.style_settings.qr_style.image = ""
    if (this._data.style_settings.qr_middle_logo_id) {

      const setCrossOrigin = (image_url: string) => {
        if (this.functions.is_valid_url(image_url)) {
          overhead_delay = true
          time_cc = 2 * time_cc
          this._data.style_settings.qr_style.image = image_url
          const url = new URL(image_url)
          const crossOrigin = "crossorigin"
          if (!url.searchParams.has(crossOrigin)) {
            url.searchParams.append(crossOrigin, crossOrigin)
            this._data.style_settings.qr_style.image = url.href
          }
        }
      }

      if (this.custom_logo_id === this._data.style_settings.qr_middle_logo_id) {
        this._data.style_settings.qr_style.image = this.file_helper.input_url
      } else {
        const svg = this.session_info.resources.qr_logos.find(ql => ql.id === this._data.style_settings.qr_middle_logo_id)
        if (svg?.svg) {
          const svg_element = this.qrGeneratorService.createElementFromHTML(svg.svg)
          // Change color
          const elemts = Array.from(svg_element.querySelectorAll(`path,rect,polygon,circle,g`))
          for (let item of elemts) {
            if (item.hasAttribute("fill")) item.setAttribute("fill", this._data.style_settings.qr_style.dotsOptions.color)
          }
          this._data.style_settings.qr_style.image = this.qrGeneratorService.svgToSource(svg_element)
        } else if (this.functions.is_valid_url(svg?.url)) {
          setCrossOrigin(svg.url)
        }
      }
    }

    if (!this.qrCode) {
      this.qrCode = new QRCodeStyling(this._data.style_settings.qr_style);
      this.qrCode.append(this.qrContainer)
    } else {
      this.qrCode.update(this._data.style_settings.qr_style)
    }
    const canvas = this.qrContainer.querySelectorAll("canvas")[this.qrContainer.querySelectorAll("canvas").length - 1]
    this.primary_color_obs.next(this._data.style_settings.qr_style.dotsOptions.color)

    if (overhead_delay) {
      // Waste time a bit
      try {
        this.functions.logToConsole("Overhead delay")
        await this.functions.getImage(this._data.style_settings.qr_style.image)
      } catch (error) {
        this.functions.logToConsole(error)
      }
    }

    clearTimeout(this.timer_cc)
    this.timer_cc = setTimeout(() => {
      this._data.processing = false
      this._data.qr_url = canvas.toDataURL("image/svg", 1)
      this.saveProgress()
    }, time_cc)

  }

  saveProgress() {
    let _index = this.session_info.qr_generating.drafts.findIndex(d => d.selected_category == this.selected_category)
    if (_index === -1)
      this.session_info.qr_generating.drafts.push(this._data)
    else
      this.session_info.qr_generating.drafts[_index] = this._data
    this.coreService.setSessionData(this.session_info, false)
    this.functions.logToConsole(this._data)
  }

  async fileChangeEvent(event: any) {

    if (!event.target.files.length) return

    const file: File = event.target.files[0]
    let file_type = file.name.split(".").pop()?.toLowerCase() as QrDownloadFileTypes
    let allowed_image_types = [QrDownloadFileTypes.JPG, QrDownloadFileTypes.JPEG, QrDownloadFileTypes.PNG]
    if (!allowed_image_types.includes(file_type)) {
      this.file_helper.error = `.${file_type} is not a supported image format, please select a different image`
      return
    }

    this.file_helper.base64 = await this.functions.base64FromFile(file)
    this.file_helper.input_url = `${this.file_helper.base64.header},${this.file_helper.base64.body}`
    this.file_helper.file = file
    this._data.style_settings.qr_middle_logo_id = this.custom_logo_id
    this.finishImageUpload()
  }

  async finishImageUpload(reset = false) {
    this.file_helper.showing = false

    if (reset) {
      this.file_helper.base64 = null
      this.file_helper.input_url = ""
      this.file_helper.file = null
      if (this.custom_logo_id === this._data.style_settings.qr_middle_logo_id) {
        this._data.style_settings.qr_middle_logo_id = ""
        this.regenerateQR()
      }
      return
    }
    this.regenerateQR()

  }

  download(extension: QrDownloadFileTypes = QrDownloadFileTypes.PNG) {

    let link = document.createElement('a');
    link.download = `BrandQRCodes ${this._data.selected_category} ${Math.random() + 1}.${extension}`
    var b64Start = 'data:image/svg+xml;base64,'

    const miscellaneous = () => {
      if (!this.logged.find(l => l.text === this._data.style_settings.qr_style.data && l.extension === extension)) {
        // TODO:: Show marketing modal

        // Send to BE
        this.coreService.notifyBackEnd(LandingPageLoggerDataModes.QR_GENERATED, { ext: extension, text: this.coreService.encrypt(this._data.style_settings.qr_style.data) })
        this.logged.push({
          extension,
          text: this._data.style_settings.qr_style.data
        })
      }
    }

    if (!this._data.style_settings.frame.type) {

      if (QrDownloadFileTypes.SVG === extension) {
        miscellaneous()
        link.href = this.qrGeneratorService.sourceToSVG(document.getElementById("noframe_console").getAttribute("src"))
        link.click()
        return
      }

      miscellaneous()
      this.qrCode.download({ extension, name: "BrandQRCodes " + this._data.selected_category + (Math.random() + 1) })
      return
    }

    var svg = document.getElementById(`svg_${this._data.style_settings.frame.type}`);

    var xml = new XMLSerializer().serializeToString(svg);
    var svg64 = btoa(xml);
    var image64 = b64Start + svg64;

    if (QrDownloadFileTypes.SVG === extension) {
      miscellaneous()
      link.href = image64
      link.click()
      return
    }

    let img = new Image()
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    canvas.width = this.qrGeneratorService.getFrameSettings().find(({ type }) => type === this._data.style_settings.frame.type)?.width || 1000
    canvas.height = this.qrGeneratorService.getFrameSettings().find(({ type }) => type === this._data.style_settings.frame.type)?.height || 1000
    img.onload = () => {
      miscellaneous()
      ctx.drawImage(img, 0, 0);
      var imgURL = canvas.toDataURL("image/svg", 1);
      link.href = imgURL;
      link.click()
    }

    img.src = image64

  }
}
